module.exports = ".markets-news-list {\n  font-family: ArialMT, Arial, Helvetica, sans-serif;\n}"